import Accordion from 'accordion-js';

window.addEventListener('load', () => {
  const accordionElements = Array.from(document.querySelectorAll('.js-accordion-container:not(.education-components)'));
  if (accordionElements.length > 0) {
    const accordions = new Accordion(accordionElements, { duration: 300 });
  }

  // education components

  const educationElements = Array.from(document.querySelectorAll('.education-components'));

  if (educationElements.length > 0) {
    const educationAccordions = new Accordion(educationElements, { duration: 300 });

    educationAccordions[0].open(0)
  }
});
